import React, { useCallback, useRef } from 'react'

import Select from 'react-select'

function DriverInfoDropdown({ name, label, placeholder, value, onChange, options, disabled, search, wrapperClassName, classNamePrefix = 'dropdown', validationObject }) {
  const dropdownRef = useRef()

  const handleLabelClick = useCallback(() => {
    if (dropdownRef.current) {
      dropdownRef.current.focus()
    }
  }, [dropdownRef])

  const hasError = (!validationObject?.isValid) || false
 
  return (
    <div className={wrapperClassName}>
      <label onClick={handleLabelClick} className='text-center'>{label}</label>
      <Select
        ref={dropdownRef}
        openMenuOnFocus={true}
        name={name}
        value={value}
        onChange={onChange}
        options={options}
        isSearchable={search}
        placeholder={placeholder}
        isDisabled={disabled}
        className={`dropdown ${hasError ? 'error' : ''}`}
        classNamePrefix={classNamePrefix}
      />
      {hasError && <div style={{ textAlign: 'center', color: '#EE7402', fontSize: '12px' }}>{validationObject?.message}</div>}
    </div>
  )
}

export default DriverInfoDropdown
